import { BarChart3, MapPin, QrCode } from "lucide-react";

interface HeaderProps {
  route: string;
  onRouteChange: (route: string) => void;
}

export function Header({ route, onRouteChange }: HeaderProps) {
  return (
    <header className="app-header">
      <div className="header-brand">
        <div className="brand-mark">P</div>
        <div>
          <strong>Posterly</strong>
          <span>Lectify poster tracking</span>
        </div>
      </div>
      <nav className="header-nav">
        <button className={route === "/logger" ? "active" : ""} onClick={() => onRouteChange("/logger")}>
          <QrCode size={18} /> Logger
        </button>
        <button className={route === "/dashboard" ? "active" : ""} onClick={() => onRouteChange("/dashboard")}>
          <BarChart3 size={18} /> Dashboard
        </button>
        <a href="/p/MOD-001" target="_blank" rel="noreferrer">
          <MapPin size={18} /> Test scan
        </a>
      </nav>
    </header>
  );
}
